import { Component, OnInit, inject } from '@angular/core';
import {DataService} from '../services/data.service';
import {AccessService} from '../services/access.service';
import moment from 'moment';
import {DatePipe, DecimalPipe, NgForOf, NgIf} from "@angular/common";
import {BaseChartDirective} from "ng2-charts";
import {ChartConfiguration, } from "chart.js";
import {flag} from "../pipes/flag.pipe";

@Component({
    selector: 'app-dashboard',
    imports: [DecimalPipe, NgForOf, BaseChartDirective, NgIf, flag, DatePipe],
    styles: `
        h3 {
            margin-top: 10px;
        }

        .card:hover {
            cursor: pointer;
            filter: brightness(0.9);
        }

        .number {
            background: var(--primary-sidebar);
            color: var(--primary);
            border-radius: 20px;
            width: 35px;
            height: 35px;
            text-align: center;
            padding-top: 8px;
            font-weight: bold;
            margin-top: 2px;
        }
    `,
    template: `
        <h2 class="fw-bold">Dashboard</h2>
        <div class="text-muted" style="font-size: 1.05rem">Daten Vortag ({{ yesterday | date: 'EEEE' }}, {{ yesterday | date: 'dd.MM.yyyy' }})</div>

        <div class="row my-3" *ngIf="stats">
            <div class="col-sm-12 col-md-4 mb-1">
                <div class="card">
                    <div class="card-body">
                        <div class="text-muted">Gesamtumsatz</div>

                        <h3 class="fw-bold mb-0">€ {{ stats.turnover_yesterday | number: '1.0-0' }}</h3>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-md-4 mb-1">
                <div class="card">
                    <div class="card-body">
                        <div class="text-muted">Franchiseumsatz</div>

                        <h3 class="fw-bold mb-0">€ {{ stats.franchise_yesterday | number: '1.0-0' }}</h3>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-md-4 mb-1">
                <div class="card">
                    <div class="card-body">
                        <div class="text-muted">Gesamtkunden</div>

                        <h3 class="fw-bold mb-0">{{ stats.sales_yesterday | number: '1.0-0' }}</h3>
                    </div>
                </div>
            </div>
        </div>

        <div class="d-md-none d-sm-block mb-3" *ngIf="stats">
            <div class="text-muted" style="font-size: 1.05rem">Top {{ stats.top_stores_yesterday.length }} Stores</div>

            <div class="card mt-2" *ngFor="let store of stats.top_stores_yesterday; let i = index">
                <div class="card-body p-2">
                    <div class="d-flex">
                        <div class="flex-shrink-0">
                            <div class="ms-1">
                                @if (i == 0) { <img src="assets/img/gold.png" class="img-fluid" style="width: 40px"> }
                                @if (i == 1) { <img src="assets/img/silver.png" class="img-fluid" style="width: 40px"> }
                                @if (i == 2) { <img src="assets/img/bronze.png" class="img-fluid" style="width: 40px"> }
                                @if (i > 2) { <div class="number ms-1">{{ i + 1 }}</div> }
                            </div>
                        </div>
                        <div class="flex-grow-1 ms-3">
                            <div class="mb-0"><span class="fi fi-{{ store.country | flag }} me-1"></span> {{ store.name }}</div>
                            <small class="text-muted" style="font-size: 0.8rem">€ {{ store.turnover | number: '1.2-2' }}</small>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="text-muted" style="font-size: 1.05rem">Übersicht der wichtigsten Kennzahlen mit Vorjahresvergleich YTD</div>

        <div class="row mt-3" *ngIf="stats">
            <div class="col-sm-12 col-fifth mb-1">
                <div class="card">
                    <div class="card-body">
                        <div class="text-muted">Gesamtumsatz</div>

                        <h3 class="fw-bold mb-0">€ {{ stats.turnover | number: '1.0-0' }}</h3>
                        <small>
                    <span [class.text-success]="stats.turnover_diff > 0" [class.text-danger]="stats.turnover_diff < 0">
                        @if (stats.turnover_diff > 0) {<i class="fa-solid fa-arrow-trend-up me-1"></i>}
                        @if (stats.turnover_diff < 0) {<i class="fa-solid fa-arrow-trend-down me-1"></i>}
                        € @if(stats.turnover_diff > 0) {+}{{ stats.turnover_diff | number: '1.0-0' }}
                    </span> vs Vorjahr
                        </small>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-fifth mb-1">
                <div class="card">
                    <div class="card-body">
                        <div class="text-muted">Franchiseumsatz</div>

                        <h3 class="fw-bold mb-0">€ {{ stats.franchise | number: '1.0-0' }}</h3>
                        <small>
                    <span [class.text-success]="stats.franchise_diff > 0" [class.text-danger]="stats.franchise_diff < 0">
                        @if (stats.franchise_diff > 0) {<i class="fa-solid fa-arrow-trend-up me-1"></i>}
                        @if (stats.franchise_diff < 0) {<i class="fa-solid fa-arrow-trend-down me-1"></i>}
                        € @if(stats.franchise_diff > 0) {+}{{ stats.franchise_diff | number: '1.0-0' }}
                    </span> vs Vorjahr
                        </small>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-fifth mb-1">
                <div class="card">
                    <div class="card-body">
                        <div class="text-muted">Gesamtkunden</div>

                        <h3 class="fw-bold mb-0">{{ stats.sales | number: '1.0-0' }}</h3>
                        <small>
                    <span [class.text-success]="stats.sales_diff > 0" [class.text-danger]="stats.sales_diff < 0">
                        @if (stats.sales_diff > 0) {<i class="fa-solid fa-arrow-trend-up me-1"></i>}
                        @if (stats.sales_diff < 0) {<i class="fa-solid fa-arrow-trend-down me-1"></i>}
                        @if(stats.sales_diff > 0) {+}{{ stats.sales_diff | number: '1.0-0' }}
                    </span> vs Vorjahr
                        </small>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-fifth mb-1">
                <div class="card">
                    <div class="card-body">
                        <div class="text-muted">Durchschnittswarenkorb</div>

                        <h3 class="fw-bold mb-0">€ {{ stats.average | number: '1.2-2' }}</h3>
                        <small>
                    <span [class.text-success]="stats.average_diff > 0" [class.text-danger]="stats.average_diff < 0">
                        @if (stats.average_diff > 0) {<i class="fa-solid fa-arrow-trend-up me-1"></i>}
                        @if (stats.average_diff < 0) {<i class="fa-solid fa-arrow-trend-down me-1"></i>}
                        € @if(stats.average_diff > 0) {+}{{ stats.average_diff | number: '1.2-2' }}
                    </span> vs Vorjahr
                        </small>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-fifth mb-1">
                <div class="card">
                    <div class="card-body">
                        <div class="text-muted">Stores</div>

                        <h3 class="fw-bold mb-0">{{ stats.stores | number: '1.0-0' }}</h3>
                        <small>
                    <span [class.text-success]="stats.stores_diff > 0" [class.text-danger]="stats.stores_diff < 0">
                        @if (stats.stores_diff > 0) {<i class="fa-solid fa-arrow-trend-up me-1"></i>}
                        @if (stats.stores_diff < 0) {<i class="fa-solid fa-arrow-trend-down me-1"></i>}
                        @if(stats.stores_diff > 0) {+}{{ stats.stores_diff | number: '1.0-0' }}
                    </span> vs Vorjahr
                        </small>
                    </div>
                </div>
            </div>
        </div>

        <div class="row mt-2">
            <div class="col-sm-12 col-md-8 mb-1">
                <div class="card">
                    <div class="card-body">
                        <h3 class="fw-bold mt-0">Umsatzanalyse</h3>
                        <div class="text-muted">Umsatz und Veränderung zum Vorjahr nach Store</div>

                        <div *ngIf="stats?.stores_data" [style.height.px]="stats.stores_data.length * 50 + 100" class="d-none d-md-block">
                            <canvas baseChart
                                    [data]="chart.data"
                                    [options]="chart.options"
                                    [type]="chart.type">
                            </canvas>
                        </div>

                        <div class="d-md-none mt-3" *ngIf="stats?.stores_data">
                            <table class="table table-striped">
                                <thead>
                                <tr>
                                    <th>Store</th>
                                    <th class="text-end">Umsatz</th>
                                    <th class="text-end">Umsatz Vorjahr</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr *ngFor="let store of stats.stores_data">
                                    <td>{{ store.name }}</td>
                                    <td class="text-end">€ {{ store.turnover | number: '1.0-0' }}</td>
                                    <td class="text-end">€ {{ store.turnover_prev | number: '1.0-0' }}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-md-4 mb-1">
                <div class="card">
                    <div class="card-body">
                        <h3 class="fw-bold mt-0">Top 5 Stores</h3>
                        <div class="text-muted mb-4">Beste Performance nach Umsatz (€) dieses Jahr</div>

                        <div class="card mt-2" *ngFor="let store of topStores; let i = index">
                            <div class="card-body p-2">
                                <div class="d-flex">
                                    <div class="flex-shrink-0">
                                        <div class="number ms-1">{{ i + 1 }}</div>
                                    </div>
                                    <div class="flex-grow-1 ms-3">
                                        <div class="mb-0"><span class="fi fi-{{ store.country | flag }} me-1"></span> {{ store.name }}</div>
                                        <small class="text-muted" style="font-size: 0.8rem">€ {{ store.turnover | number: '1.2-2' }}</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `
})
export class DashboardComponent implements OnInit {

    accessService = inject(AccessService);
    private dataService = inject(DataService);

    stats: any;
    chart!: ChartConfiguration;
    topStores: any[] = [];
    yesterday = moment().subtract(1, 'days').toDate();

    ngOnInit(): void {
        const year = moment().year();

        this.dataService.request("Dashboard/getStats", {
            year: year
        }).subscribe(response => {
            this.stats = response.stats;

            this.stats.stores_data = this.stats.stores_data.filter((store: any) => store.turnover > 0);

            this.stats.turnover_diff = this.stats.turnover - this.stats.turnover_prev;
            this.stats.sales_diff = this.stats.sales - this.stats.sales_prev;
            this.stats.franchise_diff = this.stats.franchise - this.stats.franchise_prev;
            this.stats.stores_diff = this.stats.stores - this.stats.stores_prev;

            //this.stats.average = this.stats.turnover / this.stats.sales;
            //this.stats.average_prev = this.stats.turnover_prev / this.stats.sales_prev;
            this.stats.average_diff = this.stats.average - this.stats.average_prev;
            this.stats.average_diff = Number(this.stats.average_diff.toFixed(2));

            this.topStores = this.stats.stores_data.slice(0, 5);

            const prevColor = getComputedStyle(document.documentElement)
                .getPropertyValue('--primary-sidebar').trim();

            this.chart = {
                data: {
                    labels: this.stats.stores_data.map((store: any) => store.name),
                    datasets: [
                        {
                            label: String(year),
                            data: this.stats.stores_data.map((store: any) => store.turnover),
                            backgroundColor: this.accessService.client.primaryColor,
                            borderColor: this.accessService.client.primaryColor,
                            borderRadius: 8,
                            borderSkipped: 'start',
                        },
                        {
                            label: String(year - 1),
                            data: this.stats.stores_data.map((store: any) => store.turnover_prev),
                            backgroundColor: prevColor,
                            borderColor: prevColor,
                            borderRadius: 8,
                            borderSkipped: 'start',
                        }
                    ],
                },
                options: {
                    indexAxis: 'y',
                    maintainAspectRatio: false,
                    plugins: {
                        legend: {
                            position: 'bottom'
                        },
                        tooltip: {
                            enabled: false
                        },
                        datalabels: {
                            anchor: 'end',
                            align: 'left',
                            color: '#000',
                            font: {
                                weight: 'bold'
                            },
                            formatter: (value: number) => {
                                if (value == 0) return '';
                                return '€ ' + Number(value).toLocaleString('de-DE', { maximumFractionDigits: 2 });
                            }
                        }
                    },
                    elements: {
                        bar: {
                            borderRadius: 8,
                            borderSkipped: false,
                        }
                    },
                    /*datasets: {
                        bar: {
                            barThickness: 12,
                            maxBarThickness: 12,
                            categoryPercentage: 1.0,
                        }
                    }*/
                },
                type: 'bar',
            };
        })
    }

}
